import { assert } from '../lib/assert';

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '/api';

function getLoginUrl(): string {
  assert(typeof API_BASE === 'string', 'VITE_API_BASE_URL must be set');
  // Strip trailing /v1 if present (login is top-level /auth, not /v1)
  const base = API_BASE.replace(/\/v1\/?$/, '');
  assert(base.length > 0, 'API base must not be empty');
  return `${base}/auth/login`;
}

export function Login() {
  const loginUrl = getLoginUrl();

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="card p-8 w-full max-w-md text-center">
        <h1 className="text-2xl tracking-tight mb-1">TknBudget</h1>
        <p className="text-sm text-[color:var(--mute)] mb-6">Sign in to your workspace</p>
        <a
          href={loginUrl}
          className="block w-full bg-[color:var(--accent)] text-[color:var(--ink-0)] font-semibold py-2 rounded hover:opacity-90 text-center"
        >
          Sign in with WorkOS
        </a>
      </div>
    </div>
  );
}
